export enum HttpMethodsEnum {
    Put,
    Post,
    Patch,
    Get,
}
